$(document).on('click', '#use-payment-device-checkbox', () => {
  use_device = $('#use-payment-device-checkbox').prop('checked')

  if (use_device) {
    $('.payment-browser-form').prop('disabled', true)
    $('.payment-device-form').prop('disabled', false)
  } else {
    $('.payment-browser-form').prop('disabled', false)
    $('.payment-device-form').prop('disabled', true)
  }
});

$(document).on('click', '#use-offline-mode-checkbox', () => {
  use_offline = $('#use-offline-mode-checkbox').prop('checked')

  if (use_offline) {
    $('.offline-mode-form').show()
  } else {
    $('.offline-mode-input').val('')
    $('.offline-mode-form').hide()
  }
});